import Grid from '@mui/material/Grid2';
import React from 'react';
import { Control } from 'react-hook-form';
import { IFormField } from '../../../../../shared/interfaces/forms/IForms';
import { IUser } from '../../../../../shared/interfaces/user/IUser';
import FormField from '../FormField';
interface IProps {
  control: Control<IUser>;
  formFields: IFormField[];
}
const AccountAccess = ({ control, formFields }: IProps) => {
  return (
    <Grid container spacing={2}>
      {formFields?.map((userKey) => (
        <FormField userKey={userKey} control={control} key={userKey.key} />
      ))}
    </Grid>
  );
};

export default AccountAccess;
